import React, { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Firebase from "../../../services/firebase";
import Recommendation from "../../commons/recommendation/Recommendation.component";
import {ReactComponent  as Logo} from "../../../img/Fixel_Logo2019vector1.svg";
import {
	FormContainer,
	StyledInput,
	StyledSignIn,
	StyledForm,
	StyledLabel,
	StyledFormWrapper,
	StyledLeftForm,
	StyledRightForm,
	StyledStar,
	StyledButton,
	Row
} from "./signin.style";
import { ActionRow, ErrorContainer, StyledTitle } from "../../style/global.style";
import StateContext from "../../../context/StateContext";
import SmallLoader from "../../utils/SmallLoader";
import { sendEvent } from "../../../services/analytics";
import { captureException } from "services/sentry";

const SignIn = () => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState(null);
	const [signInSpinner, setSignInSpinner] = useState(false);
	const { dispatch, ACTIONS } = useContext(StateContext);
	const history = useHistory();

	const signInWithEmailAndPassword = async (event) => {
		event.preventDefault();
		setSignInSpinner(true);
		try {
			const res = await Firebase.signInWithEmailAndPasswordHandler(event, email, password, onLoginFail);
			if (res?.user) {
				const token = await Firebase.getUserToken();
				sessionStorage.setItem("token", token);
				redirectToHome({ user: res.user, showSpinner: true, loading: true }, "user-pass");
			} else setSignInSpinner(false);
		} catch (e) {
			onLoginFail(e, "signInWithEmailAndPassword");
		}
	};

	const onLoginFail = (e, action) => {
		setSignInSpinner(false);
		setError(Firebase.handleError(e));
		captureException(e, "info", { email }, { action }, { scope: "firebase.js" });
	};
	const redirectToHome = (payload, signInType) => {
		setSignInSpinner(false);
		sendEvent({ category: "log in", action: signInType });
		dispatch({ type: ACTIONS.SET_STATE, payload });
		history.push("/");
	};

	const onChangeHandler = (event) => {
		const { name, value } = event.currentTarget;

		if (name === "userEmail") {
			setEmail(value);
		} else if (name === "userPassword") {
			setPassword(value);
		}
	};

	return (
		<StyledSignIn>
			<Logo style={{"margin": "2rem 0"}}/>
			<StyledFormWrapper>
				<StyledLeftForm>
					{error && <ErrorContainer className={"shake"}>{error}</ErrorContainer>}
					{!error && <div></div>}
					<FormContainer>
						<StyledTitle>Log in to your account</StyledTitle>
						<StyledForm onSubmit={signInWithEmailAndPassword}>
							<StyledLabel htmlFor="userEmail">
								Email
								<StyledStar>*</StyledStar>
							</StyledLabel>
							<StyledInput
								required
								disabled={signInSpinner}
								type="email"
								className="my-1 p-1 w-full"
								name="userEmail"
								value={email}
								placeholder="name@email.com"
								id="userEmail"
								autocomplete="email"
								onChange={onChangeHandler}
							/>
							<StyledLabel htmlFor="userPassword">
								Password
								<StyledStar>*</StyledStar>
							</StyledLabel>
							<StyledInput
								required
								disabled={signInSpinner}
								type="password"
								className="mb-3 p-1 w-full"
								name="userPassword"
								value={password}
								placeholder="********"
								id="userPassword"
								autocomplete="current-password"
								onChange={onChangeHandler}
							/>
							<Row className={"mt-1"}>
								<StyledButton type="submit" disabled={signInSpinner}>
									{signInSpinner ? <SmallLoader inline={true} /> : "Log In"}
								</StyledButton>
							</Row>
						</StyledForm>
						<ActionRow>
							<p>Don't have an account yet?</p>
							<Link disabled={signInSpinner} to="signup">
								Sign up here
							</Link>
						</ActionRow>
						<ActionRow>
							<p>Forgot password?</p>
							<Link disabled={signInSpinner} to="password-reset">
								Retrieve your password here
							</Link>
						</ActionRow>
					</FormContainer>
				</StyledLeftForm>
				<StyledRightForm>
					<Recommendation />
				</StyledRightForm>
			</StyledFormWrapper>
		</StyledSignIn>
	);
};
export default React.memo(SignIn);
